import { render, staticRenderFns } from "./RunMenu.vue?vue&type=template&id=4c8f52be&scoped=true&"
import script from "./RunMenu.vue?vue&type=script&lang=js&"
export * from "./RunMenu.vue?vue&type=script&lang=js&"
import style0 from "./RunMenu.vue?vue&type=style&index=0&id=4c8f52be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8f52be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VCard,VCardSubtitle,VCardText,VCardTitle,VDivider,VIcon})
